module.exports = __webpack_public_path__ + "static/media/privacy_policy.2d826bcd.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/privacy_policy.pdf
// module id = 89
// module chunks = 29